export default "__VITE_ASSET__9cf17a54__"